import {
  Accessibility, CalendarCheck, Car, Check, CreditCard, Leaf, Music, PawPrint,
  ShoppingBag, Sun, Users, Utensils, Wifi, Wine, Wind,
} from "lucide-react";

// A plain word is enough to pick the right mark; anything unrecognised gets a tick.
const ICONS = [
  { test: /outdoor|terrace|patio|garden|rooftop/, Icon: Sun },
  { test: /family|kid|child/, Icon: Users },
  { test: /takeout|take-out|to go|delivery/, Icon: ShoppingBag },
  { test: /reservation|book|table/, Icon: CalendarCheck },
  { test: /wifi|wi-fi/, Icon: Wifi },
  { test: /parking|valet/, Icon: Car },
  { test: /pet|dog/, Icon: PawPrint },
  { test: /accessib|wheelchair/, Icon: Accessibility },
  { test: /card|payment|cash/, Icon: CreditCard },
  { test: /air condition|a\/c|climate/, Icon: Wind },
  { test: /bar|drink|cocktail|wine/, Icon: Wine },
  { test: /music|dj|live/, Icon: Music },
  { test: /vegetarian|vegan|plant/, Icon: Leaf },
  { test: /food|kitchen|menu/, Icon: Utensils },
];

const iconFor = (label) => ICONS.find(({ test }) => test.test(String(label).toLowerCase()))?.Icon || Check;

/** The place in its own words, with the handful of facts worth scanning. */
export default function DetailAbout({ heading, editorial, description, amenities = [], tags = [] }) {
  const facts = [...amenities, ...tags].filter(Boolean).slice(0, 8);
  if (!editorial && !description && facts.length === 0) return null;

  return (
    <section id="about" className="scroll-mt-28">
      <h2 className="text-[16px] font-extrabold tracking-[-0.01em] text-[#171717] dark:text-[#f2efe9]">{heading}</h2>

      {editorial && (
        <p className="mt-2 text-[14px] font-medium leading-[1.7] text-[#24231f] dark:text-[#f0ede6]">{editorial}</p>
      )}
      {description && (
        <p className={"text-[13.5px] leading-[1.75] text-[#55554f] dark:text-[#c5c1b8] " + (editorial ? "mt-2.5" : "mt-2")}>{description}</p>
      )}

      {facts.length > 0 && (
        <div className="mt-4 grid grid-cols-2 gap-x-3 gap-y-3 sm:grid-cols-3">
          {facts.map((fact) => {
            const Icon = iconFor(fact);
            return (
              <div key={fact} className="flex min-w-0 items-center gap-2">
                <Icon className="h-4 w-4 shrink-0 text-[#55554f] dark:text-[#c5c1b8]" strokeWidth={1.8} />
                <span className="min-w-0 truncate text-[12px] font-semibold text-[#3f3f3c] dark:text-[#ded9d1]">{fact}</span>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}